import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc, collection, onSnapshot } from 'firebase/firestore';
import { useAuth } from './AuthContext';

const SecurityContext = createContext();

export const useSecurity = () => useContext(SecurityContext);

export const SecurityProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [isBanned, setIsBanned] = useState(false);
  const [deviceId, setDeviceId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // 1. Get or Generate Device ID
    let id = localStorage.getItem('listen2_device_id');
    if (!id) {
      id = 'dev_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('listen2_device_id', id);
    }
    setDeviceId(id);

    // 2. Listen for Ban Status
    const checkBan = () => {
      const banRef = collection(db, 'banned_users');
      
      // We check for either the current UID or the device ID
      const unsubscribe = onSnapshot(banRef, (snapshot) => {
        const bannedIds = snapshot.docs.map(doc => doc.id);
        const banned = (currentUser && bannedIds.includes(currentUser.uid)) || bannedIds.includes(id);
        setIsBanned(banned);
        if (banned) {
          localStorage.setItem('listen2_banned', 'true');
        } else {
          localStorage.removeItem('listen2_banned');
        }
        setIsLoading(false);
      });

      return unsubscribe;
    };

    return checkBan();
  }, [currentUser]);

  const banUser = async (id, reason = 'Suspicious activity') => {
    try {
      await setDoc(doc(db, 'banned_users', id), {
        bannedAt: new Date(),
        reason,
        adminId: currentUser?.uid
      });
      return true;
    } catch (error) {
      console.error("Error banning user:", error);
      return false;
    }
  };

  const unbanUser = async (id) => {
    try {
      // Typically you'd delete the doc, but for now we'll just setDoc as a placeholder
      // await deleteDoc(doc(db, 'banned_users', id));
      return true;
    } catch (error) {
      return false;
    }
  };

  return (
    <SecurityContext.Provider value={{ isBanned, deviceId, banUser, unbanUser, isLoading }}>
      {isBanned ? (
        <div style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8f9fa',
          color: '#202124',
          textAlign: 'center',
          padding: '20px'
        }}>
          <h1 style={{ fontSize: '48px', marginBottom: '16px' }}>🚫</h1>
          <h2>Access Restricted</h2>
          <p style={{ color: '#5f6368', maxWidth: '400px' }}>
            Your account or device has been flagged for suspicious activity (e.g., bot behavior or stream farming). 
            Please contact support if you believe this is an error.
          </p>
        </div>
      ) : (
        children
      )}
    </SecurityContext.Provider>
  );
};
